import script from "./QuantityCounter.vue?vue&type=script&lang=ts&setup=true"
export * from "./QuantityCounter.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__